import { styled } from 'styled-components';

export const SecurityLogosWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 16px;
`;

export const SecurityLogo = styled.img`
  height: 32px;
  width: auto;
`;
